import { getIcon } from 'features/integrations/features/ConnectedDevices/features/DeviceMap/utils/DeviceMapUtils';
import {
  openDeviceSettings,
  setSelectedDeviceId,
} from 'features/integrations/state/slices/deviceSlice';
import { setSelectedDevice } from 'features/integrations/state/thunks';
import { DeviceIsDeviceType } from 'features/integrations/utils/deviceComparisionUtils';
import DeviceMapDataView from 'pages/System/DeviceMapDataView';
import { Button } from 'react-bootstrap';
import { Marker, Popup, useMap } from 'react-leaflet';
import { useDispatch } from 'react-redux';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';

const DeviceMarker = ({
  device,
  coords,
  setMapCenter,
  setUseThisDevice,
  setShowCurrentDevice,
  setShowDeviceSettings,
}) => {
  const {
    data: connectedDevices = [],
    isLoading: connectedDevicesLoading,
    isError: connectedDevicesError,
  } = useGetConnectedDevicesQuery();
  const dispatch = useDispatch();
  const map = useMap();

  const fillDataforSimpleUSGS = async (simplePoint) => {
    const id = simplePoint.id;
    try {
    } catch (error) {
      console.error('Error fetching detailed data for USGS device:', error);
      return simplePoint; // Return original point on error
    }
  };

  const markerKey = `${device?.system_type ?? 'unknown'}-${device?.node_id}`;
  const isUSGS =
    (device?.system_type && device.system_type.toLowerCase() === 'usgs') ||
    (device?.device_type && device.device_type.toLowerCase().includes('monitoring station'));

  return (
    <Marker key={markerKey} position={coords} icon={getIcon(device)}>
      <Popup>
        <div
          style={isUSGS ? { minWidth: '20vh', maxHeight: '20vh' } : undefined}
          className="d-block flex-column align-items-center text-center gap-2 overflow-y-auto"
        >
          <DeviceMapDataView device={device} />
          <Button
            variant="primary"
            className="px-3 py-2 text-white"
            onClick={() => {
              map.closePopup();
              setMapCenter(coords);
              const found = connectedDevices.find((f) => f.id === device.id);
              if (found?.tempPoint) {
                //this branch is for USGS temporary points that are not full devices
                fillDataforSimpleUSGS(device.id); //TODO: Evaluate if this is still needed
              }
              if (found) {
                // select by device id so map, graph, and list stay in sync
                dispatch(setSelectedDevice({ index: -1, id: device.id }));
                dispatch(setSelectedDeviceId(device.id));
                setUseThisDevice(found);

                // Flood and USGS monitoring stations both open their datasheets
                const isDatasheetDevice =
                  DeviceIsDeviceType(found, 'Stage') ||
                  DeviceIsDeviceType(found, 'MonitoringStation');
                if (isDatasheetDevice) {
                  setShowCurrentDevice(true);
                } else {
                  setShowDeviceSettings(true);
                }

                if (
                  !DeviceIsDeviceType(found, 'Stage') &&
                  !DeviceIsDeviceType(found, 'MonitoringStation')
                ) {
                  dispatch(openDeviceSettings(found.id));
                }
              }
            }}
          >
            View device
          </Button>
        </div>
      </Popup>
    </Marker>
  );
};

export default DeviceMarker;
